/**
 * Save the date — pilule flottante + popover calendrier (zéro dépendance)
 * Config injectée par functions/acf/event.php (window.valEvent) ;
 * absente = rien ne s'affiche, le bouton #calendar du hero reste un lien.
 * Google Agenda : URL native. Apple/Outlook : fichier .ics généré à la volée.
 */

(function () {

	var cfg = window.valEvent;
	if (!cfg) return;

	var STORAGE_KEY = 'vdj_std_masquee';

	function icsContent() {
		return [
			'BEGIN:VCALENDAR',
			'VERSION:2.0',
			'PRODID:-//Le Val des Jeux//Save the date//FR',
			'BEGIN:VEVENT',
			'UID:' + cfg.start + '@levaldesjeux.com',
			'DTSTAMP:' + cfg.start,
			'DTSTART:' + cfg.start,
			'DTEND:' + cfg.end,
			'SUMMARY:' + cfg.nom,
			'DESCRIPTION:' + cfg.description.replace(/,/g, '\\,'),
			'LOCATION:' + cfg.lieu.replace(/,/g, '\\,'),
			'END:VEVENT',
			'END:VCALENDAR'
		].join('\r\n');
	}

	function downloadIcs() {
		var blob = new Blob([icsContent()], { type: 'text/calendar;charset=utf-8' });
		var a = document.createElement('a');
		a.href = URL.createObjectURL(blob);
		a.download = 'le-val-des-jeux.ics';
		document.body.appendChild(a);
		a.click();
		setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
	}

	// ── Popover ──

	function actionGoogle() {
		return '<a class="std-action" href="' + cfg.google + '" target="_blank" rel="noopener noreferrer">' +
			'<i class="fab fa-google"></i> Ajouter à Google Agenda</a>';
	}

	function actionApple() {
		// fichier .ics universel : Apple Calendar, Outlook, Windows, Thunderbird…
		return '<button class="std-action" type="button" data-ics>' +
			'<i class="fas fa-calendar-plus"></i> Ajouter à mon calendrier</button>';
	}

	var popover = null;

	function buildPopover() {
		popover = document.createElement('div');
		popover.className = 'std-popover';
		popover.setAttribute('role', 'dialog');
		popover.setAttribute('aria-label', 'Ajouter à mon calendrier');
		popover.innerHTML =
			'<button class="std-close" type="button" aria-label="Fermer">&times;</button>' +
			'<div class="std-titre">' + cfg.nom + '</div>' +
			'<div class="std-infos">' +
				'<span><i class="fas fa-calendar-alt"></i> ' + cfg.label + '</span>' +
				'<span><i class="fas fa-clock"></i> ' + cfg.heures + '</span>' +
				(cfg.lieu ? '<span><i class="fas fa-map-marker-alt"></i> ' + cfg.lieu + '</span>' : '') +
			'</div>' +
			actionGoogle() + actionApple();

		popover.querySelector('.std-close').addEventListener('click', closePopover);
		popover.querySelector('[data-ics]').addEventListener('click', function () {
			downloadIcs();
			closePopover();
		});
		document.body.appendChild(popover);
	}

	function closePopover() {
		if (popover) popover.classList.remove('shown');
		document.removeEventListener('click', outsideClose, true);
	}

	function outsideClose(e) {
		if (popover && !popover.contains(e.target)) closePopover();
	}

	function openPopover(trigger) {
		if (!popover) buildPopover();

		// centré au-dessus de la pilule
		var r = trigger.getBoundingClientRect();
		var left = Math.max(12, Math.min(r.left + r.width / 2 - 150, window.innerWidth - 312));
		popover.style.left = left + 'px';
		popover.style.right = 'auto';
		popover.style.bottom = (window.innerHeight - r.top + 12) + 'px';
		popover.style.top = 'auto';

		requestAnimationFrame(function () {
			popover.classList.add('shown');
			setTimeout(function () {
				document.addEventListener('click', outsideClose, true);
			}, 0);
		});
	}

	// ── Pilule flottante + voile ──

	if (cfg.pilule && !localStorage.getItem(STORAGE_KEY)) {
		var voile = document.createElement('div');
		voile.className = 'std-voile';

		var pill = document.createElement('button');
		pill.type = 'button';
		pill.className = 'std-pilule';
		pill.innerHTML =
			'<i class="fas fa-calendar-plus"></i>' +
			'<span class="std-pilule-texte"><b>' + cfg.piluleTitre + '</b><small>' + cfg.label + '</small></span>' +
			'<span class="std-pilule-fermer" role="button" aria-label="Masquer" title="Masquer">&times;</span>';

		pill.addEventListener('click', function (e) {
			if (e.target.closest('.std-pilule-fermer')) {
				closePopover();
				localStorage.setItem(STORAGE_KEY, String(Date.now()));
				if (window.gsap) {
					gsap.to(pill, { y: 140, opacity: 0, duration: 0.4, ease: 'back.in(1.5)', onComplete: function () { pill.remove(); } });
					gsap.to(voile, { opacity: 0, duration: 0.4, onComplete: function () { voile.remove(); } });
				} else {
					pill.remove();
					voile.remove();
				}
				return;
			}
			openPopover(pill);
		});

		document.body.appendChild(voile);
		document.body.appendChild(pill);

		// voile : pleine largeur, haut de 2× la pilule
		voile.style.height = (pill.offsetHeight * 2) + 'px';

		// apparition : la pilule surgit du bas avec un bump, le voile fond doucement
		if (window.gsap) {
			gsap.set(pill, { xPercent: -50, y: 140, opacity: 1 });
			gsap.to(pill, { y: 0, duration: 0.9, delay: 0.8, ease: 'back.out(1.7)' });
			gsap.to(voile, { opacity: 1, duration: 1.2, delay: 0.7, ease: 'power1.out' });
			pill.addEventListener('mousedown', function () { gsap.to(pill, { scale: 0.96, duration: 0.1 }); });
			pill.addEventListener('mouseup', function () { gsap.to(pill, { scale: 1, duration: 0.2 }); });
		} else {
			pill.style.transform = 'translateX(-50%)';
			pill.style.opacity = '1';
			voile.style.opacity = '1';
		}
	}

	// masquage expiré après 7 jours
	var masquee = localStorage.getItem(STORAGE_KEY);
	if (masquee && Date.now() - Number(masquee) > 7 * 24 * 3600 * 1000) {
		localStorage.removeItem(STORAGE_KEY);
	}

})();
